module.exports = __webpack_public_path__ + "img/nature-27.d3802afe.jpg";